module.exports = __webpack_public_path__ + "media/patrimonio-animation-en.85b00f6b.mp4";